/**
 * usePageReadyForTour
 * Hook to determine when the page is ready to start a tour
 * Combines page load state and PWA prompt visibility checks
 */

import { useEffect, useState } from 'react'
import { useCanStartTour } from './useCanStartTour'

export function usePageReadyForTour(): boolean {
  const [isPageLoaded, setIsPageLoaded] = useState(false)
  const canStartTour = useCanStartTour()

  useEffect(() => {
    // Check if page is already loaded
    if (document.readyState === 'complete') {
      setIsPageLoaded(true)
      return
    }

    // Listen for page load
    const handleLoad = () => {
      setIsPageLoaded(true)
    }

    window.addEventListener('load', handleLoad)
    return () => window.removeEventListener('load', handleLoad)
  }, [])

  return isPageLoaded && canStartTour
}
